import { UploadOption } from './interface';

export function upload({
  action,
  file,
  filename,
  data = {},
  headers = {},
  withCredentials = false,
  onProgress = () => null,
  onSuccess = () => null,
  onError = () => null,
}: UploadOption) {
  const formData = new FormData();
  const xhr = new XMLHttpRequest();

  xhr.onload = event => {
    if (!(xhr.status >= 200 && xhr.status < 300)) {
      const error = new Error(`${xhr.status} ${xhr.statusText}`);
      onError(error, { event, xhr, file });
      return;
    }

    const text = xhr.responseText || xhr.response;
    try {
      const result = JSON.parse(text);
      onSuccess(result, { event, xhr, file });
    } catch (err) {
      onSuccess(text, { event, xhr, file });
    }
  };

  xhr.onerror = event => onError(new Error('Http Request Error'), { event, xhr, file });

  if (onProgress && xhr.upload) {
    xhr.upload.onprogress = event => {
      if (event.lengthComputable && event.total) {
        onProgress(
          {
            total: event.total,
            loaded: event.loaded,
            percent: (event.loaded / event.total) * 100,
          },
          { event, xhr, file },
        );
      }
    };
  }

  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });

  formData.append(filename, file);

  xhr.open('POST', action, true);
  xhr.withCredentials = withCredentials;

  Object.keys(headers).forEach(key => {
    xhr.setRequestHeader(key, headers[key]);
  });

  xhr.send(formData);

  return xhr;
}
